import { hasProp } from '../../utils';

import type { ViewGroupProps, ViewProps } from './ListToolbar.types';

const helpers = {
  isView(view: ViewGroupProps | ViewProps): view is ViewProps {
    return hasProp(view, 'selected');
  },

  getViews(views: (ViewGroupProps | ViewProps)[]): ViewProps[] {
    return views.reduce((result, item) => {
      if (this.isView(item)) {
        result.push(item);
        return result;
      }
      return result.concat(this.getViews(item.items));
    }, [] as ViewProps[]);
  },

  updateViews(
    views: (ViewGroupProps | ViewProps)[],
    fn: (view: ViewProps, index: number) => ViewProps
  ): (ViewGroupProps | ViewProps)[] {
    return views.map((item, index) => {
      if (this.isView(item)) {
        return fn(item, index);
      }
      return {
        ...item,
        items: this.updateViews(item.items, fn)
      } as ViewGroupProps;
    });
  },

  selectView(
    views: (ViewGroupProps | ViewProps)[],
    id: ViewProps['id']
  ): (ViewGroupProps | ViewProps)[] {
    return this.updateViews(views, view => {
      return {
        ...view,
        selected: view.id === id
      };
    });
  },

  getSelectedView(views: (ViewGroupProps | ViewProps)[]): ViewProps | undefined {
    return views.reduce(
      (result, item) => {
        if (result) return result;
        if (this.isView(item)) {
          return item.selected ? item : undefined;
        }
        return this.getSelectedView(item.items);
      },
      undefined as ViewProps | undefined
    );
  }
};

export default helpers;
